/**
 * Decide which per-component actions a session component exposes.
 *
 * PAUSED components are sessions halted out of quota. The engine resumes
 * them in place via retry_component_session (ComponentSessionStatus.canRetry
 * covers FAIL and PAUSED), so a paused component gets the same "retry" resume
 * affordance as a failed one — not the force-start "re-run" that spawns a new
 * session, which would be misleading for a resume.
 *
 * @param {{status?: string, type?: string}} component
 * @param {boolean} isTrigger whether the component type is a workflow trigger
 */
export function getSessionComponentActionVisibility(component, isTrigger) {
  const status = component?.status;
  const type = component?.type;
  const isPaused = status === "PAUSED";

  const showRerun =
    !isTrigger &&
    type !== "loop_through_list" &&
    status !== "FAIL" &&
    status !== "INPROGRESS" &&
    !isPaused;
  const showRetry = status === "FAIL" || isPaused;
  const showTerminate = status === "WAITING" || status === "INPROGRESS";
  const showRerunOnLatest = !isTrigger || type === "form";

  return { showRerun, showRetry, showTerminate, showRerunOnLatest };
}
